import { render, staticRenderFns } from "./vxeTreeGrid.vue?vue&type=template&id=928d5914&scoped=true&"
import script from "./vxeTreeGrid.vue?vue&type=script&lang=ts&"
export * from "./vxeTreeGrid.vue?vue&type=script&lang=ts&"
import style0 from "./vxeTreeGrid.vue?vue&type=style&index=0&id=928d5914&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928d5914",
  null
  
)

export default component.exports